import React, { useState } from 'react';
import Disclaimer from '../Components/Legal/Disclaimer';
import ReturnPolicy from '../Components/Legal/ReturnPolicy';
import TermsAndConditions from '../Components/Legal/TermsAndConditions';
import { 
    MDBFooter,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBBtnGroup,
    MDBIcon,
 } from 'mdb-react-ui-kit';
 

const Footer = ({className}) => {

  const [active1, setActive1] = useState(false);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);

  const activateTerms = () => {
    setActive1(!active1);
  }
  const activateDisclaimer = () => {
    setActive2(!active2);
  }
  const activateReturnPolicy = () => {
    setActive3(!active3);
  }

  return (
    <div className='mt-5'>
     <MDBFooter className={`text-black mx-auto ${className}`}> {/*style={{ backgroundColor: 'rgba(0, 0, 0, .8)', position: 'relative', border: '1px solid rgba(0, 0, 0, .2)', borderRadius: '10px', width: '20rem' }}>*/} 
          <MDBContainer className='p-4 pb-0'>
            <div>
              <MDBBtn outline color="white" floating className='m-1 bgOverlay' size='lg' href='https://twitter.com/SocietalLabs' target='_blank' role='button'>
                <MDBIcon fab icon='twitter' />
              </MDBBtn>
              <MDBBtn outline color="white" floating className='m-1 bgOverlay' size='lg' href='https://discord.gg/sPrmfjeD7B' target='_blank'  role='button'>
                <MDBIcon fab icon='discord' />
              </MDBBtn>
            </div>
            <div className='text-center p-3 text-black'>
            © 2022 Copyright<br></br>
            <a className='text-black' href='https://societal-labs.com'>
              Societal Labs LLC
            </a>
            </div>
            <MDBRow className='pt-2'>
              <MDBCol size='12' className='d-flex justify-content-center'>
                <MDBBtnGroup className='mb-4' aria-label='Legal Buttons'>
                  <MDBBtn outline color="white" style={{border: '1px solid white'}} onClick={activateDisclaimer} className='link text-white bgOverlay'>Disclaimer</MDBBtn>
                  {active2 === true && <Disclaimer setActive={setActive2}/>}
                  <MDBBtn outline color="white" onClick={activateTerms} className='link text-white bgOverlay'>Terms</MDBBtn>
                  {active1 === true && <TermsAndConditions active={active1} setActive={setActive1}/>}
                  <MDBBtn outline color="white" onClick={activateReturnPolicy} className='link text-white bgOverlay'>Return Policy</MDBBtn>
                  {active3 === true && <ReturnPolicy setActive={setActive3}/>}
                </MDBBtnGroup>
              </MDBCol>
            </MDBRow> 
          </MDBContainer>
        </MDBFooter>
        </div>
  )
}

export default Footer;